import React, { useEffect, useState } from 'react'
import { Control, Controller } from 'react-hook-form'
import useIndexAgent from '../../../services/agent/hooks/useIndexAgent'
import Select from 'react-select'

interface AgentSelectComponentProps {
    control: Control<any>,
    errors: any,
}

interface SelectOption {
    value: string,
    label: string,
}

const AgentSelectComponent: React.FC<AgentSelectComponentProps> = ({ control, errors }) => {
    const defaultAgent = {
        value: 'direct',
        label: 'Direct',
    }
    const [agentOptions, setAgentOptions] = useState<SelectOption[]>([defaultAgent])
    const { data: agents, isFetching, isError } = useIndexAgent({
        filters: {
            all: 1,
        }
    })

    useEffect(() => {
        if (agents) {
            const options = agents.data.map((agent) => ({
                value: agent.id,
                label: agent.name,
            }))
            setAgentOptions([defaultAgent, ...options])
        }
    }, [agents])

    return (
        <>
            <label htmlFor="agent_id" className="col-sm-4 col-form-label d-flex" style={{ fontSize: '14px' }}>Agent:</label>
            <Controller
                name="agent_id"
                control={control}
                render={({ field }) => (
                    <Select
                        {...field}
                        options={agentOptions}
                        defaultValue={defaultAgent}
                        onChange={(selected) => {
                            if (selected) {
                                field.onChange(selected.value);
                            }
                        }}
                        isDisabled={isFetching || isError}
                        isLoading={isFetching}
                        placeholder="Select Agent"
                        value={agentOptions.find((option) => option.value === field.value)}
                    />
                )}
            />
            {errors.agent_id && <span className="text-danger">{errors.agent_id.message}</span>}
        </>
    )
}

export default AgentSelectComponent